import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import type { Resolver } from 'react-hook-form';

const localizationSchema = z.object({
  title: z.string().min(1, "Can't be empty"),
  body: z.string().min(1, "Can't be empty"),
  language: z.string().min(1, "Can't be empty"),
  description: z.string(),
});

const schema = z.object({
  title: z.string().min(1, "Can't be empty"),
  body: z.string().min(1, "Can't be empty"),
  language: z.string().min(1, "Can't be empty"),
  tag: z.string().min(1, "Can't be empty"),
  additional_flows_ids: z.number().array().default([]),
  default_flows_ids: z.number().array().default([]),
  description: z.string(),
  localizations: z.array(localizationSchema).refine(
    (localizations) => {
      return localizations.every((loc) => {
        return loc.title && loc.body && loc.language;
      });
    },
    {
      message: 'Please fill in all required fields in localizations',
      path: ['localizations'],
    }
  ),
});

export default {
  schema,
  resolver: zodResolver(schema),
} as {
  schema: typeof schema;
  resolver: Resolver<z.infer<typeof schema>>;
};
